module.exports = __webpack_public_path__ + "img/ctrl-berkeley-dagger-stub-+.881fdd15.svg";